<div class="px-[0px] md:px-[88px] bg-[#EEF1F5] mt-[-48px] py-[24px] h-[calc(100vh-128px)] overflow-auto">
  @if (isLoading) {
  <app-supscribe-page-loading />
  }@else {
  <p-button (onClick)="location.back()" [label]="'translate_back'|translate" [icon]="commonService.getLang() === 'ar' ?'fas fa-angle-right me-2':'fas fa-angle-left me-2'" [link]="true" />
  <div class="bg-white rounded-[16px] border-[1px] border-solid border-[#DDE4EB] mt-[45px] grid grid-cols-1 md:grid-cols-3 gap-[0rem] md:gap-[1.5rem] ">
    <div
      class=" bg-[#FAFCFD] rounded-s-[16px] relative border-e-[1px] border-solid border-[#DDE4EB] py-[61px] px-[32px]">
      <div class="absolute top-[0] left-[50%] flex gap-[6px]" style="transform: translate(-50%, -50%);">
        @if (plans) {
        @for (plan of plans; track $index) {
          <button (click)="onPlanSelect(plan)"
          [ngClass]="{'text-white bg-gradient-to-r from-[#7A5AF8] to-[#6938EF] button-active-shadow':selectedPlan === plan}"
          class="cursor-pointer px-[16px] py-[8px] md:px-[24px] md:py-[9px]  w-[max-content] h-[max-content] hover:text-[#6938EF] hover:border-[#6938EF] rounded-[6px] bg-[#FFFFFF] border-[1px] border-solid border-[#EEF1F5] text-[14px] md:text-[16px] font-medium leading-[24px] text-[#394551] button-shadow">
          {{plan.name}}  @if (currentPlan && plan.name === currentPlan.name) { <span class="block md:inline">{{'(Current)'}}</span> }</button>
        }
        }
      </div>
      @if (selectedPlan) {
      @for (feature of plansService.getSortedFeatures(selectedPlan.features); track $index) {
      <div class="flex gap-[8px] mb-[16px]">
        @if(feature.isExist){
        <div
          class="w-[20px] h-[20px] rounded-[50%] bg-[#6938EF] text-[#FFFFFF] text-[12px] flex justify-center items-center">
          ✓</div>
        }@else {
        <div
          class="w-[20px] h-[20px] rounded-[50%] bg-[#C5D5DC] text-[#FFFFFF] text-[12px] flex justify-center items-center">
          ❌</div>
        }
        <p class="text-[12px] font-normal leading-[18px] text-[#000]">{{commonService.getLang() === 'ar'?
          feature.nameAr: feature.nameEn }}</p>
        <p class="text-[12px] font-normal leading-[18px] text-[#000] cursor-help"
          pTooltip="{{commonService.getLang() === 'ar'? feature.descriptionAr : feature.descriptionEn }}"
          tooltipPosition="top">{{commonService.getLang() === 'ar'? '؟' : '?' }}</p>
      </div>
      }
      }
      <!-- --------------- Summary --------------- -->
      <!-- <div class="mb-2 flex items-center justify-between">
        <h2 class="text-gray-900	font-bold	text-lg">{{'translate_summary'|translate}}</h2>
        <p class="text-xs text-slate-500">{{'Mon Feb 10 2025' }}</p>
      </div>

      <div class="mb-2 flex items-center justify-between">
        <p class="text-xs text-slate-500">{{ 'Annual'|translate}}</p>
        <p class="text-xs text-slate-700 font-bold">{{'EGP2,880.00'}}</p>
      </div>

      <div class=" mb-2 flex items-center justify-between">
        <p class="text-xs text-slate-500">{{'translate_est_tax' |translate }}</p>
        <p class="text-xs text-slate-700 font-bold	">$0.00</p>
      </div>

      <div class="mb-2 flex items-center justify-between">
        <p class="text-xs text-slate-500">{{'translate_total_inc_tax'|translate}}</p>
        <p class="text-xs text-slate-700 font-bold"> {{'EGP2,880.00'}}</p>
      </div> -->
    </div>


    <div class="col-span-2 p-[32px]">
      <h1 class="text-[24px] font-semibold leading-[36px] text-[#141E27] mb-2">
        {{'Glamera_Subscription_Plans'|translate}}</h1>
      <p class="text-[14px] font-normal leading-[21px] text-[#6C7680] ">{{'Explore_our_plans'|translate}}</p>
      <div class="border-b-[1px] border-solid border-[#DDE4EB] w-full mt-[24px] mb-[20px]"></div>

      <!-- <h1 class="text-[24px] font-semibold leading-[36px] text-[#141E27] inline">Current Plan </h1>
      <span class="text-[20px] font-normal leading-[30px] text-[#4A5662]">({{subscriptionDetails.subscriptionPlanName}} - {{getPlanType(subscriptionDetails.cycle) |translate}})</span>
      <p class="text-[14px] font-normal leading-[21px] text-[#6C7680] mb-[45px]">Plan Duration: {{subscriptionDetails.startDate |date:'fullDate'}} – {{subscriptionDetails.endDate |date:'fullDate'}}</p> -->

      <h1 class="text-[14px] font-semibold leading-[21px] text-[#141E27] mb-2">Discover Plans
        <span class="cursor-help"
          pTooltip="{{commonService.getLang() === 'ar'? 'لوريم إيبسوم هو نص وهمي' : 'Lorem Ipsum is simply dummy' }}"
          tooltipPosition="top">{{commonService.getLang() === 'ar'? '؟' : '?' }}</span>
      </h1>
      <p class="text-[12px] font-normal leading-[18px] text-[#6C7680] mb-[30px]">We show monthly costs to highlight
        discounts forlonger subscriptions</p>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-[12px]">
        @if (selectedPlan) {
        @for (plan of getPlanCycles(selectedPlan); track $index) {
        <div class="bg-[#F5F7FA] rounded-[12px] border-[1px] border-solid border-[#DDE4EB] p-3 w-full">
          <h1 class="text-[24px] font-semibold leading-[36px] text-[#141E27] mb-[8px]">
            {{plansService.getPlanType(plan.cycle)|translate}}</h1>

          <h1 class="text-[28px] font-semibold leading-[42px] text-[#141E27] mb-[8px] inline">
            {{plan.currency}}
            @if (plan.cycle === 30) {{{(plan.price).toFixed(1) }}}
            @else if (plan.cycle === 90) {{{(plan.price / 3).toFixed(1) }}}
            @else if (plan.cycle === 360) {{{(plan.price / 12).toFixed(1) }}}
          </h1>
          <span class="text-[14px] font-normal leading-[21px] text-[#141E27] mb-[8px]">/
            {{plansService.getPlanType(30)|translate}}</span>
          <p class="text-[14px] font-normal leading-[21px] text-[#141E27] mb-[8px]">
            @if (plan.cycle === 30) { {{'translate_billed'|translate}}
            {{plansService.getPlanType(plan.cycle)|translate}} }
            @else { {{plan.currency}} {{plan.price}} {{'translate_billed'|translate}}
            {{plansService.getPlanType(plan.cycle)|translate}} }
          </p>
          <p class="text-[14px] font-normal leading-[21px] text-[#141E27]">{{'translate_est_tax'|translate}}: 14%</p>
          @if (subscriptionDetails && currentPlan && plan.cycle == subscriptionDetails.cycle && currentPlan.name === selectedPlan.name) {
            <p class="text-[14px] font-normal leading-[21px] text-[#ef4444] mt-2">End in : {{subscriptionDetails.endDate |date:'fullDate'}}</p>
          }@else{
            <div class="h-[21px] mt-2"></div>
          }

          <div class="border-b-[1px] border-solid border-[#DDE4EB] w-full mt-[24px] mb-[20px]"></div>


        <!-- Check if selected plan is the same as current plan -->
          @if (currentPlan && selectedPlan && selectedPlan.order === currentPlan.order) {
            <div class="cursor-not-allowed text-[#94A1AE] border-[1px] border-solid border-[#94A1AE] w-full flex justify-center items-center py-[9px] rounded-[8px] text-[16px] font-semibold leading-[24px]">
              {{'translate_choose_plan'|translate}}
            </div>
          <!-- If selected plan order is greater than current plan order (upgrade) -->
          }@else if (currentPlan && selectedPlan && selectedPlan.order > currentPlan.order) {
            @if (subscriptionDetails && plan.cycle !== subscriptionDetails.cycle) {
              <!-- Disabled upgrade button for different cycle -->
              <div class="cursor-not-allowed text-[#94A1AE] border-[1px] border-solid border-[#94A1AE] w-full flex justify-center items-center py-[9px] rounded-[8px] text-[16px] font-semibold leading-[24px]">
                {{'translate_upgrade_plan'|translate}}
              </div>
            }@else {
              <!-- Enabled upgrade button for same cycle -->
              <div (click)="handleCheckSubscriptionChange(plan)" class="cursor-pointer w-full flex justify-center items-center py-[9px] rounded-[8px] hover:bg-gradient-to-r from-[#7A5AF8] to-[#6938EF] hover:text-white bg-[#FFFFFF] border-[1px] border-solid border-[#6938EF] text-[16px] font-semibold leading-[24px] text-[#6938EF]">
                {{'translate_upgrade_plan'|translate}}
              </div>
            }
          <!-- If selected plan order is less than current plan order (downgrade) -->
          }@else if(currentPlan && selectedPlan && selectedPlan.order < currentPlan.order) {
            @if (subscriptionDetails && plan.cycle !== subscriptionDetails.cycle) {
              <!-- Disabled downgrade button for different cycle -->
              <div class="cursor-not-allowed text-[#94A1AE] border-[1px] border-solid border-[#94A1AE] w-full flex justify-center items-center py-[9px] rounded-[8px] text-[16px] font-semibold leading-[24px]">
                {{'translate_downgrade_plan'|translate}}
              </div>
            }@else {
              <!-- Enabled downgrade button for same cycle -->
              <div (click)="handleDowngradePlan(plan)" class="cursor-pointer w-full flex justify-center items-center py-[9px] rounded-[8px] hover:bg-gradient-to-r from-[#7A5AF8] to-[#6938EF] hover:text-white bg-[#FFFFFF] border-[1px] border-solid border-[#6938EF] text-[16px] font-semibold leading-[24px] text-[#6938EF]">
                {{'translate_downgrade_plan'|translate}}
              </div>
            }
          }


          <!-- <button
            [ngClass]="{'text-[#94A1AE] border-[#94A1AE] ':getStatus('cycle'+plan.cycle) === 'Current Plan'}"
            (click)="openPaymentMethodDialog()"
            class="cursor-pointer w-full flex justify-center items-center py-[9px] rounded-[8px] hover:bg-gradient-to-r from-[#7A5AF8] to-[#6938EF] hover:text-white bg-[#FFFFFF] border-[1px] border-solid border-[#6938EF] text-[16px] font-semibold leading-[24px] text-[#6938EF]">
            @if (getStatus('cycle'+plan.cycle) === 'Current Plan') {<span
              class="mx-2 border-2 border-solid border-gray-400 rounded-full text-gray-400 h-5 w-5 flex justify-center items-center text-xs">✓</span>}
            {{getStatus('cycle'+plan.cycle) | translate}}</button> -->


        </div>
        }
        }
      </div>


    </div>




  </div>
  }
  <img src="../../../assets/Glamera-logo.png" alt="glamera logo" class="mx-auto mt-4 mb-3" />
  <p class="mt-[24px] text-[13px] font-normal leading-[19.5px] text-[#4A5662] w-full text-center mx-auto">{{'translate_change_policy'|translate}}</p>
  <p class="text-[13px] font-normal leading-[19.5px] text-[#4A5662] w-full text-center mx-auto">{{'translate_upgrade_description'|translate}}</p>
  <p class="text-[13px] font-normal leading-[19.5px] text-[#4A5662] w-full text-center mx-auto">{{'translate_downgrade_description'|translate}}</p>

</div>
<p-confirmDialog styleClass="w-full md:w-[50vw]" />
